// ==============================|| CONFIG - HOOKS ||============================== //

// Define the static, hard-coded default configuration
const defaultConfig = {
    // Hard-code your desired font family here
    fontFamily: "Roboto, sans-serif", // Example font
    presetColor: "default", // Keeping presetColor hard-coded for theme
};

export default function useConfig() {
    const state = defaultConfig;

    return {state};
}
